import React from 'react';
import axios from 'axios';
import './App.css';
import UseCaseAnalysis from './components/UseCaseAnalysis';
import AuthGate from './components/AuthGate';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

function UserChip({ user }) {
  const handleLogout = async () => {
    await axios.post(`${API_BASE}/auth/logout`, {}, { withCredentials: true });
    window.location.href = '/';
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
      {user.picture && (
        <img
          src={user.picture}
          alt={user.name}
          style={{ width: '32px', height: '32px', borderRadius: '50%' }}
          referrerPolicy="no-referrer"
        />
      )}
      <div style={{ textAlign: 'right', lineHeight: 1.3 }}>
        <div style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-primary)' }}>{user.name}</div>
        <button
          onClick={handleLogout}
          style={{ background: 'none', border: 'none', padding: 0, color: 'var(--text-muted)', fontSize: '0.78rem', cursor: 'pointer' }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthGate>
      {(user) => (
        <div className="app">
          {/* Header */}
          <header className="app-header">
            <div className="header-content">
              <div className="logo-section">
                <div className="logo-icon">🎨</div>
                <div>
                  <h1>Category AI</h1>
                  <p className="subtitle">Use case &amp; business classification for Printo.in orders</p>
                </div>
              </div>
              <UserChip user={user} />
            </div>
          </header>

          {/* Main Content */}
          <main className="app-main">
            <UseCaseAnalysis />
          </main>

          {/* Footer */}
          <footer className="app-footer">
            <p>© 2026 Printo | Category AI - Powered by Gemini Vision</p>
          </footer>
        </div>
      )}
    </AuthGate>
  );
}

export default App;
